import React from 'react';

import {
    GoogleMapsLoader,
    GeoSearch,
} from 'react-instantsearch-dom-maps';

import { CompanySearchMapMarker } from '/components/company-search/components';

const CompanySearchMap = ({ activeHit, setActiveHit }) => (
    <GoogleMapsLoader apiKey="AIzaSyD9hmyMtGQU1RnXKUgJK1LZQNXsH5mS6xE">
        {(google) => (
            <GeoSearch
                className="testje"
                google={google}
                styles={[
                    {
                        "featureType": "poi",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    }
                ]}
                minZoom={5}
                maxZoom={18}
                initialZoom={8}
                initialPosition={{
                    lat: 50.884089,
                    lng: 4.6353907,
                }}
                enableRefine={true}
                enableRefineOnMapMove={false}
            >
                {({ hits }) => (
                    <React.Fragment>
                        {hits.map(hit => (
                            <CompanySearchMapMarker
                                hit={hit}
                                onClick={() =>{ setActiveHit(hit); }}
                                active={activeHit && activeHit.id === hit.id}
                                key={hit.id}
                            />
                        ))}
                    </React.Fragment>
                )}
            </GeoSearch>
        )}
    </GoogleMapsLoader>
);

export { CompanySearchMap };
